"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DentalMonitoringIntegrationKey_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var DentalMonitoringIntegrationPatient_1 = require("./DentalMonitoringIntegrationPatient");
var Location_1 = require("./Location");
var User_1 = require("./User");
var DentalMonitoringIntegrationKey_Factory = /** @class */ (function () {
    function DentalMonitoringIntegrationKey_Factory() {
    }
    DentalMonitoringIntegrationKey_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            DentalMonitoringIntegrationPatients: model.DentalMonitoringIntegrationPatients && model.DentalMonitoringIntegrationPatients.map(function (i) { return DentalMonitoringIntegrationPatient_1.DentalMonitoringIntegrationPatient_Factory.CreateIncoming(i); }),
            Location: Location_1.Location_Factory.CreateIncoming(model.Location),
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
            User: User_1.User_Factory.CreateIncoming(model.User),
            UserId: model.UserId,
        };
        return result;
    };
    DentalMonitoringIntegrationKey_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            DentalMonitoringIntegrationPatients: model.DentalMonitoringIntegrationPatients && model.DentalMonitoringIntegrationPatients.map(function (i) { return DentalMonitoringIntegrationPatient_1.DentalMonitoringIntegrationPatient_Factory.CreateOutgoing(i); }),
            Location: Location_1.Location_Factory.CreateOutgoing(model.Location),
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
            User: User_1.User_Factory.CreateOutgoing(model.User),
            UserId: model.UserId,
        };
        return result;
    };
    return DentalMonitoringIntegrationKey_Factory;
}());
exports.DentalMonitoringIntegrationKey_Factory = DentalMonitoringIntegrationKey_Factory;
